import { render, staticRenderFns } from "./Levelcomponents.vue?vue&type=template&id=58f5ffd3&scoped=true&"
import script from "./Levelcomponents.vue?vue&type=script&lang=js&"
export * from "./Levelcomponents.vue?vue&type=script&lang=js&"
import style0 from "./Levelcomponents.vue?vue&type=style&index=0&id=58f5ffd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5ffd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VForm,VRow})
